// @NOTE: assumes jQuery is included by WP
const $ = jQuery

class header {
  constructor () {
    this.$mobileNavButton     = $(".mobile-btn") 
    this.$closeMobileButton   = $(".close-mobile-nav")
    this.$mobileNavBg         = $(".mobile-nav-bg-curtain")
    this.$siteHeader          = $(".header-primary")
    this.$megaMenuList        = $('.mega-menu')
    this.$megaMenu            = $('.mega-menu > span')
    this.$menuItemHasChildren = $('.menu-item-has-children > a')
    this.$menuLink            = $('.elementor-nav-menu .menu-item-has-children > a')

    var delay = 100; setTimeout(function(){
      $('.elementor-tab-title').removeClass('elementor-active');
      $('.elementor-tab-content').css('display', 'none');
    }, delay);

    this.$mobileNavButton.click(function () { 
      $(".navigation").addClass('menu-open')
      $(".mobile-nav-bg-curtain").addClass('menu-open')
    }); 

    this.$closeMobileButton.click(function () { 
      $(".navigation").removeClass('menu-open') 
      $(".mobile-nav-bg-curtain").removeClass('menu-open')
    }); 

    this.$mobileNavBg.click(function () { 
      $(".navigation").removeClass('menu-open') 
      $(".mobile-nav-bg-curtain").removeClass('menu-open')
    });

    /* If mobile browser, prevent click on parent nav item from redirecting to URL */
    // if(is_touch_device()) {
 
    //     $('.main-menu-wrapper li > ul').each(function (index, elem) {
    //         /* Option 1: Use this to modify the href on the <a> to # */
    //         //$(elem).prev('a').attr('href' ,'#');   
             
    //         /* OR Option 2: Use this to keep the href on the <a> intact but prevent the default action */
    //         $(elem).prev('a').click(function(event) {
    //             event.preventDefault();
    //         });
    //     });
    // }

    setTimeout(() => {
      $('.spinner-decimal').prev('.input-group-addon').addClass('addon-icon').css('display', 'table-cell');
      $('.spinner-decimal').parents('.col-md-6').addClass('addon-icon-wrapper');
      $('.checkout_products_wrap').prev('h3').addClass('card-title');
      console.log();
    }, 1500)

    this.mobileMenuToggle()
  }

  mobileMenuToggle () {
    this.$menuItemHasChildren.on('click', (event) => {    
      let windowWidth = $(window).width()
      if(windowWidth < 1024) {
        event.preventDefault()
        if($(event.currentTarget).hasClass('clicked')) {
          let pageLink = $(event.currentTarget).attr('href')
          window.location.href = pageLink
        }
        $(event.currentTarget).next('.sub-menu').slideToggle()
        $(event.currentTarget).toggleClass('clicked')

        
      }  
    })
  }

  onWindowScroll (scrollTop) {
    if (scrollTop >= 20) {
      this.$siteHeader.addClass('js-fixed-header')
    } else {
      this.$siteHeader.removeClass('js-fixed-header')
    }
  }

  // onWindowResize (windowWidth) {
  //   this.$menuItemHasChildren.on('click', (event) => {
  //     event.preventDefault()    
  //     if(windowWidth < 1024) { 
  //       $(event.currentTarget).next('.sub-menu').toggleClass('show')  
  //     }
  //   })  
  // }
}

export default header


// WEBPACK FOOTER //
// ./src/js/custom/header/header.js